"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StopType = exports.ePortStopType = exports.eAddressStopType = void 0;
var eAddressStopType;
(function (eAddressStopType) {
    eAddressStopType["PICKUP"] = "PICKUP";
    eAddressStopType["DELIVERY"] = "DELIVERY";
    eAddressStopType["ADDITIONAL"] = "ADDITIONAL";
})(eAddressStopType = exports.eAddressStopType || (exports.eAddressStopType = {}));
var ePortStopType;
(function (ePortStopType) {
    ePortStopType["PORT_OF_LOADING"] = "PORT_OF_LOADING";
    ePortStopType["PORT_OF_DISCHARGE"] = "PORT_OF_DISCHARGE";
})(ePortStopType = exports.ePortStopType || (exports.ePortStopType = {}));
exports.StopType = Object.assign(Object.assign({}, eAddressStopType), ePortStopType);
//# sourceMappingURL=index.js.map